var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCorreios(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMin slice",
    style: {
      width: "100%",
      overflow: "visible"
    },
    viewBox: "0 0 445.3 91.2",
    overflow: "scroll",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st4{fill:#0BBBEF;}\n\t.st5{fill:#FFD500;}\n\t.st6{fill:#06416A;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.8418,
    y1: 28.8938,
    x2: 10.0538,
    y2: 74.824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#D49F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDD00"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.7,91.2h-4c-3.2,0-6.1-1.5-8-3.9L0.7,62.9C0.3,62.3,0,61.6,0,60.8c0-0.8,0.3-1.5,0.7-2.1l19.1-24.4 c1.9-2.4,4.7-3.9,8-3.9H70l-24,30.1L28.5,82.6L31.7,91.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.0161,
    y1: 75.8603,
    x2: 27.2177,
    y2: 75.8603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D49F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB5808"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,60.8l-0.2-0.3L28.5,82.6c-0.7,0.9-1.3,2.1-1.3,4.1c0,2,1.9,4.5,5.7,4.5H70L46.3,60.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.9278,
    y1: 62.2183,
    x2: 114.8193,
    y2: 16.3725
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00537E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#18AAE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#107BC0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.3,8.6L93.1,0h4c3.2,0,6.1,1.5,8,3.9l19.1,24.4c0.4,0.6,0.7,1.3,0.7,2.1c0,0.8-0.3,1.5-0.7,2.1L105,56.9 c-1.9,2.4-4.7,3.9-8,3.9H54.8l24-30.1L96.3,8.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.8037,
    y1: -4.211,
    x2: 66.7936,
    y2: 15.329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#002542"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004169"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.6,30.4l0.2,0.3L96.3,8.6c0.7-0.9,1.3-2.1,1.3-4.1c0-2-1.9-4.5-5.7-4.5H54.8L78.6,30.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.3,8.2c0.7-0.9,1.1-1.9,1.1-3.1c0-2.8-2.3-5.1-5.1-5.1H92C94.8,0,97,2.3,97,5.1c0,1.2-0.4,2.3-1.1,3.1 L78.6,30.4L54.9,60.7L97.3,8.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27.6,83c-0.7,0.9-1.1,1.9-1.1,3.1c0,2.8,2.3,5.1,5.1,5.1h1.3c-2.8,0-5.1-2.3-5.1-5.1c0-1.2,0.4-2.3,1.1-3.1 l17.4-22.2L70,30.5L27.6,83z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M283.2,42.8c-2.4,0-4.3,0.3-6.3,0.9c-3.2,1-5.6,2.7-7.4,5.1c-3.1,4-3,8.8-3,8.8v33.4h8.9c0.6,0,1-0.5,1-1V58.3 c0-0.6,0.1-2.8,1.3-3.9c1-0.9,2.3-1.3,3.6-1.5c1.4-0.2,2.8-0.1,3.5,0c0,0,0.1,0,0.2,0c0.7,0,1.2-0.4,1.5-0.9l4.6-7.9 C288.7,43.2,286.1,42.7,283.2,42.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M257,42.8c-2.4,0-4.4,0.3-6.3,0.9c-3.2,1-5.6,2.7-7.4,5.1c-3.1,4-3,8.8-3,8.8v33.4h8.9c0.6,0,1-0.5,1-1V58.3 c0-0.6,0.1-2.8,1.3-3.9c1-0.9,2.3-1.3,3.6-1.5c1.4-0.2,2.8-0.1,3.5,0c0,0,0.1,0,0.2,0c0.6,0,1.2-0.4,1.5-0.9L265,44 C262.4,43.2,259.9,42.7,257,42.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M179.2,78.7c-0.3-0.4-0.9-0.7-1.5-0.7c-0.3,0-0.7,0.1-0.9,0.3l0,0c-3,1.8-6.6,2.9-10.4,2.9 c-11.2,0-20.3-9.1-20.3-20.4c0-11.2,9.1-20.3,20.3-20.3c3.8,0,7.4,1,10.4,2.9c0.3,0.2,0.6,0.3,1,0.3c0.6,0,1.1-0.3,1.5-0.7l5.1-6.6 c-5-3.7-11.2-5.9-18-5.9c-16.8,0-30.4,13.6-30.4,30.4c0,16.8,13.6,30.4,30.4,30.4c6.7,0,12.9-2.2,18-5.9L179.2,78.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M314.3,51.7L314.3,51.7c6.6,0,12.2,4.3,14.2,10.2h-28.3C302.2,56,307.8,51.7,314.3,51.7 M314.3,42.1 c-13.5,0-24.5,11-24.5,24.5c0,13.4,11,24.4,24.5,24.5c0.2,0,0.7,0,0.7,0c5.3,0,9.6-0.7,15.3-4.4l0.9-0.6c0,0-5-6.5-5.1-6.6 c-0.3-0.4-0.9-0.7-1.4-0.7c-0.3,0-0.6,0.1-0.9,0.2c-1.3,0.7-5.2,2.4-9.5,2.4c-6.5,0-12-4.1-14.1-9.9h33.6l3.9,0c0.6,0,1-0.5,1-1 l0.1-2.8c0-0.4,0-0.7,0-1.1C338.9,53.1,327.9,42.1,314.3,42.1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M345.6,91.2c-0.6,0-1-0.4-1-1V44.7c0-0.5,0.4-1,1-1h7.9c0.6,0,1,0.5,1,1v45.5c0,0.6-0.5,1-1,1H345.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.7,51.5L210.7,51.5c-8.2,0-14.8,6.6-14.8,14.8s6.6,14.8,14.8,14.8c8.2,0,14.8-6.6,14.8-14.8 S218.9,51.5,210.7,51.5 M210.7,91.2c-13.7,0-24.8-11.1-24.8-24.8c0-13.7,11.1-24.8,24.8-24.8c13.7,0,24.8,11.1,24.8,24.8 C235.5,80,224.4,91.2,210.7,91.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M384.1,51.9L384.1,51.9c-8.1,0-14.7,6.6-14.7,14.7c0,8.1,6.6,14.6,14.7,14.6c8.1,0,14.7-6.6,14.7-14.6 C398.8,58.5,392.2,51.9,384.1,51.9 M384.1,91.1c-13.6,0-24.6-11-24.6-24.6c0-13.6,11-24.6,24.6-24.6c13.6,0,24.6,11,24.6,24.6 C408.7,80.1,397.7,91.1,384.1,91.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M436.6,62.8c-1.7-0.8-3.9-1.3-6.3-1.9c-3.5-0.9-6.8-1.1-8-3c-1.1-1.8-0.5-3.8,1-4.9c3.5-2.4,8.2-1.4,10.8-0.2 c0.5,0.2,2.4,1.3,2.4,1.3c0.3,0.2,0.6,0.3,0.9,0.3c0.6,0,1.1-0.3,1.5-0.8c0,0,5-6.4,5-6.4l-0.8-0.7c-0.5-0.4-1.2-0.8-1.9-1.2 c-1.5-0.8-6-3.4-12.5-3.4c-0.2,0-0.4,0-0.6,0c-14.3,0.3-16.3,10.4-16.3,14c0,5.4,2.8,9.3,7,11.7c3.4,1.9,9.7,3,12.9,4 c1.7,0.5,2.9,1.7,3.4,2.8c0.2,0.5,0.3,1,0.3,1.6c0.1,1.9-0.9,4-3.7,4.9c-3.1,0.9-7.9,0.5-12.3-2.9c-0.1-0.1-0.6-0.5-0.8-0.6 c-0.2-0.1-0.4-0.1-0.7-0.1c-0.6,0-1.1,0.3-1.5,0.8c-0.1,0.1-4.9,6.3-4.9,6.3s1.7,1.4,2.3,1.8c2.8,2.1,7.8,4.9,14.3,4.9h0.2 c13.8,0,17-9.8,17-15.2C445.3,70.5,442,65.2,436.6,62.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCorreios);
export default __webpack_public_path__ + "static/media/logoCorreios.d83c0d981bc8ad03b0d7442585c1ffd7.svg";
export { ForwardRef as ReactComponent };